import { render } from "./Logo.vue?vue&type=template&id=739f7c5e"
const script = {}

import exportComponent from "/home/reportadmin/public_html/app_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__